import React from "react";

const Kotlin_For_Loop = () => {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Kotlin For Loop</h1>
      <p>Content for Kotlin For Loop goes here.</p>
    </div>
  );
};

export default Kotlin_For_Loop;
